import { Button } from "@mantine/core";
import { Link, useNavigate } from "react-router-dom";
import { type IClient } from "src/pages/Management/Clients/Clients.types";
import { StyledTd, StyledTr } from "src/styled";

interface Props {
  row: IClient;
}

const ClientRow = ({ row }: Props) => {
  const navigate = useNavigate();
  const to = `/management/clients/organizations/${row.clid}`;
  return (
    <StyledTr hover onClick={() => navigate(to)} style={{ cursor: "pointer" }}>
      <StyledTd>{row.clientname}</StyledTd>
      <StyledTd center>{row.yachts}</StyledTd>
      <StyledTd center style={{ width: 200 }}>
        <Button component={Link} to={to} w="90%" variant="outline">
          View
        </Button>
      </StyledTd>
    </StyledTr>
  );
};

export default ClientRow;
